import * as React from "react";
import { Divider, Spin, Typography } from "antd";
import { IIndexNonHarmonizedReportPresenter } from "../../presenter/IndexNonHarmonizedReportPresenter";
import IndexHarmonizationReportParamBox from "../components/IndexHarmonizationReportParamBox";
import IndexHarmonizationReportPreview from "../components/IndexHarmonizationReportPreview";
import { FileExcelOutlined } from "@ant-design/icons";

export interface Props {}

export interface State extends IIndexNonHarmonizedReportPresenter {}

export default class IndexNonHarmonizedReportPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      organisationIndexCategories,
      setOrganisationIds,
      getData,
      data,
      setCategoryId,
      organisations,
      selectedCategoryId,
      user
    } = this.state;

    return (
      <Spin spinning={this.state.loaders.projectLoader}>
        <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
          <IndexHarmonizationReportParamBox
            translate={translate}
            organisationIndexCategories={organisationIndexCategories}
            setOrganisationIds={setOrganisationIds}
            getData={getData}
            setCategoryId={setCategoryId}
            selectedCategoryId={selectedCategoryId}
            user={user}
          />
          <Divider type={"vertical"} style={{ height: "100%" }} />
          {
            <div style={{ width: "75%", paddingLeft: 10 }}>
              <div>
                <Typography.Title style={{ fontSize: 20 }}>
                  {translate("reports.non_harmonised_index_data_report")}
                </Typography.Title>
              </div>

              <Spin spinning={this.state.loaders.reportLoader}>
                {data && data.length > 0 && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        float: "right",
                        marginBottom: 20
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          textAlign: "right"
                        }}
                      >
                        <Divider
                          type={"vertical"}
                          style={{ fontSize: 10, height: "100%" }}
                        />
                        <a
                          key="file-excel"
                          rel="noopener noreferrer"
                          href={`/api/reports/non-harmonized-report/xlsx?categoryTypeId=${selectedCategoryId}`}
                          target="_blank"
                        >
                          <FileExcelOutlined
                            style={{ fontSize: 20, color: "#20744B" }}
                          />
                        </a>
                      </div>
                    </div>

                    <IndexHarmonizationReportPreview
                      translate={translate}
                      organisations={organisations}
                      data={data}
                      title={translate(
                        "reports.non_harmonised_index_data_report"
                      )}
                      loader={this.state.loaders.report1Loader}
                      selectedCategory={organisationIndexCategories.find(
                        (item) => item.id === selectedCategoryId
                      )}
                    />
                  </div>
                )}
                {selectedCategoryId && data && data.length === 0 && (
                  <Typography.Title style={{ fontSize: 17, marginTop: "4em" }}>
                    {translate("reports.no_data")}
                  </Typography.Title>
                )}
              </Spin>
            </div>
          }
        </div>
      </Spin>
    );
  }
}
